import styled from 'styled-components';

/* eslint-disable-next-line */
export interface MiChatComponentsProps {}

const StyledMiChatComponents = styled.div`
  color: pink;
`;

export function MiChatComponents(_props: MiChatComponentsProps) {
  return (
    <StyledMiChatComponents>
      <h1>Welcome to MiChatComponents!</h1>
    </StyledMiChatComponents>
  );
}

export default MiChatComponents;
